// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__2CK9s","shimmer":"styles_shimmer__3YunS"};